<template>
  <div>
    <div class="col-12 row pr-0">
      <div class="col-md-9 my-3 color-gray-6 font-16 text-justify">
        <span>
          {{ title }}
        </span>
      </div>
      <div class="col-md-3 d-flex justify-content-end">
        <radio-button
          ref="radioButtonRef"
          :change-event="onChange"
          class="radio-button-container"
          :question-lists="options"
        />
      </div>
    </div>
    <div
      v-if="showSignaturePanel && !selectedIsElectronicSignature"
      class="col-12 row pr-0"
    >
      <signature-manuscript
        ref="InterventionPlanParticipantSignature"
        :contract-id="contractId"
        :document-save="documentSave"
        :document-saved="documentSaved"
        :document-type-id="documentTypeId"
        :intervention-plan-id="interventionPlanId"
        :is-achievement-summary="isAchievementSummary"
        :should-auto-edit="shouldAutoEditManuscript"
        :student-sie-id="studentSieId"
        @update-manuscript="handlerManuscriptParticipants"
      />
    </div>
    <div
      v-if="showSignaturePanel && selectedIsElectronicSignature"
      class="col-12 row pr-0"
    >
      <signature-electronic
        :document-type-id="documentTypeId"
        :intervention-plan-id="interventionPlanId"
        :signature-participants="selectedSignatureParticipants"
        :student-sie-id="studentSieId"
        @update:signatureParticipants="selectedSignatureParticipants = $event"
      />
    </div>
    <div v-if="showSignaturePanel">
      <signatures-specialist :writer-specialist="writerSpecialist" />
    </div>
  </div>
</template>
<script>
import RadioButton from '@/components/common/CustomRadioButton';
import SignatureManuscript from './intervention-plan-signature/SignatureManuscript.vue';
import SignatureElectronic from './intervention-plan-signature/SignatureElectronic.vue';
import SignaturesSpecialist from './intervention-plan-signature/SignaturesSpecialist.vue';
import rpContractDocumentTypes from '@/utils/constants/rpContractDocumentTypes.js';

export default {
  name: 'InterventionPlanSignature',
  components: {
    RadioButton,
    SignatureManuscript,
    SignatureElectronic,
    SignaturesSpecialist,
  },
  async mounted() {
    if (typeof this.selectedIsElectronicSignature === 'boolean') {
      this.onChange({ id: this.selectedIsElectronicSignature });
    }
  },
  props: {
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    interventionPlanId: {
      type: Number,
      default: 0,
      required: false,
    },
    documentTypeId: {
      type: Number,
      default: 0,
      required: false,
    },
    studentSieId: {
      type: Number,
      default: 0,
      required: false,
    },
    isElectronicSignature: {
      type: Boolean,
      default: false,
      required: false,
    },
    writerSpecialist: {
      type: Object,
      default: () => {},
      required: false,
    },
    signatureParticipants: {
      type: Array,
      default: () => [],
      required: false,
    },
    documentSave: {
      type: Object,
      default: () => null,
    },
    documentSaved: {
      type: Boolean,
      default: () => false,
    },
    isAchievementSummary: {
      type: Boolean,
      default: () => false,
    },
    shouldAutoEditManuscript: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    showSignaturePanel: false,
  }),
  computed: {
    title() {
      const hashMap = {
        [rpContractDocumentTypes.ProgressReport]:
          '¿Cuál será el mecanismo que se estará utilizando para firmar el Informe de Progreso?',
        [rpContractDocumentTypes.InterventionPlan]:
          '¿Cuál será el mecanismo que se estará utilizando para firmar el Plan de Intervención?',
      };
      return hashMap[this.documentTypeId];
    },
    selectedIsElectronicSignature: {
      get() {
        return this.isElectronicSignature;
      },
      set(value) {
        this.$emit('update:isElectronicSignature', value);
      },
    },
    selectedSignatureParticipants: {
      get() {
        return this.signatureParticipants;
      },
      set(value) {
        this.$emit('update:signatureParticipants', value);
      },
    },
    options() {
      return {
        options: [
          {
            id: true,
            label: 'Electrónica',
            check: this.selectedIsElectronicSignature === true,
            disabled: false,
          },
          {
            id: false,
            label: 'Manuscrito',
            check: this.selectedIsElectronicSignature === false,
            disabled: false,
          },
        ],
      };
    },
  },
  methods: {
    onChange(item) {
      this.selectedIsElectronicSignature = item.id;
      this.showSignaturePanel = true;
    },
    handlerManuscriptParticipants(data) {
      this.$emit('update-manuscript', data);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

::v-deep .custom-icon {
  .dot {
    box-shadow: none !important;
    margin-right: 4px !important;
  }
  .dot.dot--has-border {
    border-color: transparent !important;
  }
  .color-gray-7.font-16.font-weight-bold {
    color: #11291b !important;
  }
}
.custom-radio-container > span:first-of-type {
  height: 100% !important;
}
.radio-button-container {
  height: 100%;
}
.radio-button-container >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
</style>
